var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleFolder2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/Google Folder@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/Google-Folder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F1F4FB",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Folder",
    mask: "url(#mask-2)",
    fill: "#2E3955",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8, 7.375)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75,2.25 L9.69960916,2.25 L7.96992177,0.659179688 C7.54804677,0.236952782 6.97851562,0 6.38085938,0 L2.25,0 C1.00722635,0 0,1.00757825 0,2.25 L0,13.5 C0,14.7424217 1.00722635,15.75 2.25,15.75 L15.75,15.75 C16.9927737,15.75 18,14.7424217 18,13.5 L18,4.5 C18,3.2589848 16.9910152,2.25 15.75,2.25 Z M2.25,1.6875 L6.38085938,1.6875 C6.53108186,1.6875 6.67241013,1.74600005 6.77847648,1.85231209 L9,3.9375 L15.75,3.9375 C16.0601481,3.9375 16.3125,4.18978107 16.3125,4.5 L16.3125,5.625 L1.6875,5.625 L1.6875,2.25 C1.6875,1.93992162 1.93992215,1.6875 2.25000054,1.6875 L2.25,1.6875 Z M15.7500005,14.0625 L2.25000054,14.0625 C1.93985188,14.0625 1.6875,13.8102189 1.6875,13.5 L1.6875,7.3125 L16.3125,7.3125 L16.3125,13.5 C16.3125,13.8093746 16.0593746,14.0625 15.75,14.0625 L15.7500005,14.0625 Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M28.4283353,24.6986178 L25.2359525,21.9365986 C23.4243039,22.1323238 22.5184796,22.2301865 22.5184796,22.2301865 C22.5184796,22.2301865 20.2244591,25.191857 20.2244591,25.191857 C20.2244591,25.191857 19.3206881,27.7881611 19.3206881,27.7881611 C19.3206881,27.7881611 20.4934645,29.5415415 20.4934645,29.5415415 C20.4934645,29.5415415 24,29.9728816 24,29.9728816 C24,29.9728816 28.4283353,29.5415415 28.4283353,29.5415415 C28.4283353,29.5415415 29.6390475,28.3201623 29.6390475,28.3201623 C29.6390475,28.3201623 30.0164513,26.8283504 30.0164513,26.8283504 C30.0164513,26.8283504 29.4870793,26.1184395 28.4283353,24.6986178 Z",
    id: "Path-3",
    fill: "#F1F4FB",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "google_cloud-icon",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18, 21)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.272875,2.76379176 L8.68928125,2.77059052 L9.8206875,1.68861694 L9.87553125,1.23018648 C8.978125,0.465617716 7.79329688,0 6.49857813,0 C4.15451563,0 2.17607813,1.52525253 1.59046875,3.59129759 C1.71396875,3.50893551 1.97803125,3.57070707 1.97803125,3.57070707 L4.2388125,3.21522922 C4.2388125,3.21522922 4.355,3.03127428 4.41390625,3.04040404 C4.94845074,2.47878835 5.70587843,2.15879747 6.5,2.15909091 C7.1703125,2.16045066 7.7878125,2.38694639 8.272875,2.76165501 L8.272875,2.76379176 Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4095312,3.5955711 C11.1468906,2.66899767 10.6055625,1.85081585 9.87492187,1.23018648 L8.272875,2.76223776 C8.91475,3.25757576 9.32648437,4.01554002 9.32648437,4.86402486 L9.32648437,5.13442113 C10.105875,5.13442113 10.7390156,5.74125874 10.7390156,6.48523699 C10.7390156,7.23057498 10.1044531,7.83605284 9.32648437,7.83605284 L6.50142187,7.83605284 L6.21867187,8.10800311 L6.21867187,9.72921523 L6.50142187,9.99825175 L9.32648437,9.99825175 C11.3540721,9.99557704 12.997091,8.42443077 13,6.48543124 C12.9985781,5.28982129 12.3703125,4.23212898 11.4095312,3.59576535 L11.4095312,3.5955711 Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67351563,10 L6.49695313,10 L6.49695313,7.83605284 L3.67351563,7.83605284 C3.47291919,7.83608576 3.27465931,7.7948804 3.09217188,7.71522922 L2.6845,7.83469308 L1.55309375,8.91666667 L1.45396875,9.28185703 C2.09155478,9.74701084 2.87137352,9.99880126 3.6733125,9.998446 L3.67351563,10 Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67351563,2.97397047 C1.64592789,2.97664518 0.00290902242,4.54779145 0,6.48679099 C0,7.62762238 0.571390625,8.64199689 1.45559375,9.28457653 L3.09359375,7.71814297 C2.58718921,7.49977131 2.26144608,7.01802745 2.26098438,6.48679099 C2.26098438,5.74145299 2.89554688,5.13597514 3.67351563,5.13597514 C4.24632813,5.13597514 4.73870313,5.46620047 4.96132813,5.93240093 L6.59932813,4.36596737 C5.92759375,3.52039627 4.86667188,2.97397047 3.67371875,2.97397047 L3.67351563,2.97397047 Z",
    fill: "#FBBC05"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleFolder2X);
export default __webpack_public_path__ + "static/media/Google Folder@2x.75a2cb3b32659596a1f80696240ef698.svg";
export { ForwardRef as ReactComponent };